import { render, staticRenderFns } from "./TableViewUpdated.vue?vue&type=template&id=f8f23344"
import script from "./TableViewUpdated.vue?vue&type=script&lang=js"
export * from "./TableViewUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports